import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectMfaData = (store: StoreSchema) => store.loginState.mfa